import { HeaderDataProps } from 'components/organisms/Header/types';

const header: HeaderDataProps = {
  name: 'Md Farhan Shahriyar',
  profilePicture: './img/person.jpg',
  job: 'Software Engineer',
};

export default header;
